export default __webpack_public_path__ + "static/media/admin_bg.722e40a8.jpg";